import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { MediaFileFragmentDoc } from '../../../fragments/__generated__/file.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetConversationMessagesQueryVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
  messagesLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  messagesBefore?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetConversationMessagesQuery = { __typename?: 'Query', conversation?: { __typename?: 'Conversation', id: string, uuid: string, name?: string | null, owner: { __typename?: 'User', id: string, email?: string | null }, lastMessage?: { __typename?: 'ChatMessage', id: string, createdAt: number, from: { __typename?: 'User', id: string } } | null, members: Array<{ __typename?: 'ChatMember', id: string, memberId: string, lastReadMessageId?: string | null, lastReadAt?: number | null, profile: { __typename?: 'User', id: string, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, photo?: { __typename?: 'File', url: string, type: Types.FileType } | null, messages: { __typename?: 'ChatMessageConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ChatMessageEdge', cursor: string, node: { __typename?: 'ChatMessage', id: string, content: string, createdAt: number, media: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, from: { __typename?: 'User', id: string, email?: string | null, username: string, firstName?: string | null, lastName?: string | null } } }> } } | null };

export type NewChatMessageSubscriptionVariables = Types.Exact<{
  roomId: Types.Scalars['ID']['input'];
}>;


export type NewChatMessageSubscription = { __typename?: 'Subscription', newMessageInConversation?: { __typename?: 'NewChatMessageEdge', cursor: string, node: { __typename?: 'ChatMessage', id: string, content: string, createdAt: number, media: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, from: { __typename?: 'User', id: string, email?: string | null, username: string, firstName?: string | null, lastName?: string | null } } } | null };

export type MessageItemFragment = { __typename?: 'ChatMessage', id: string, content: string, createdAt: number, media: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, from: { __typename?: 'User', id: string, email?: string | null, username: string, firstName?: string | null, lastName?: string | null } };

export const MessageItemFragmentDoc = gql`
    fragment MessageItem on ChatMessage {
  id
  content
  media {
    ...MediaFile
  }
  from {
    id
    email
    username
    firstName
    lastName
  }
  createdAt
}
    ${MediaFileFragmentDoc}`;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($conversationId: ID!, $messagesLimit: Int, $messagesBefore: String) {
  conversation(id: $conversationId) {
    id
    uuid
    owner {
      id
      email
    }
    lastMessage {
      id
      createdAt
      from {
        id
      }
    }
    members {
      id
      memberId
      lastReadMessageId
      lastReadAt
      profile {
        id
        username
        photoUrl
        firstName
        lastName
      }
    }
    name
    photo {
      url
      type
    }
    messages(last: $messagesLimit, before: $messagesBefore) {
      pageInfo {
        startCursor
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ...MessageItem
        }
      }
    }
  }
}
    ${MessageItemFragmentDoc}`;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      messagesLimit: // value for 'messagesLimit'
 *      messagesBefore: // value for 'messagesBefore'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables> & ({ variables: GetConversationMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
      }
export function useGetConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
// @ts-ignore
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationMessagesQuery | undefined, GetConversationMessagesQueryVariables>;
export function useGetConversationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
export type GetConversationMessagesQueryHookResult = ReturnType<typeof useGetConversationMessagesQuery>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationMessagesLazyQuery>;
export type GetConversationMessagesSuspenseQueryHookResult = ReturnType<typeof useGetConversationMessagesSuspenseQuery>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const NewChatMessageDocument = gql`
    subscription NewChatMessage($roomId: ID!) {
  newMessageInConversation(input: {id: $roomId}) {
    cursor
    node {
      ...MessageItem
    }
  }
}
    ${MessageItemFragmentDoc}`;

/**
 * __useNewChatMessageSubscription__
 *
 * To run a query within a React component, call `useNewChatMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewChatMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewChatMessageSubscription({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useNewChatMessageSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewChatMessageSubscription, NewChatMessageSubscriptionVariables> & ({ variables: NewChatMessageSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewChatMessageSubscription, NewChatMessageSubscriptionVariables>(NewChatMessageDocument, options);
      }
export type NewChatMessageSubscriptionHookResult = ReturnType<typeof useNewChatMessageSubscription>;
export type NewChatMessageSubscriptionResult = Apollo.SubscriptionResult<NewChatMessageSubscription>;